import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-component-resources';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  constructor(private fabricService: FabricService) {}

  getComponents(name?: string, version?:string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_components_mgmt_components', {name, version});
  }

  getComponentsNameVersion(name?: string, version?:string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_components_mgmt_components_name_version', {name, version});
  }

}
